import { combineReducers } from 'redux'
import fields from './fields'

const mineApp = combineReducers({
  fields
})

export default mineApp


/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/